import { ReportService, WarehouseService } from '@vega/services'

const bankingApiUri = process.env.REACT_APP_BANKING_API_URI

const getOptions = (baseUri) => ({ baseUri })

export const analyticsService = new ReportService(getOptions(bankingApiUri))
export const warehouseService = new WarehouseService(getOptions(bankingApiUri))
